module.exports = __webpack_public_path__ + "img/948-239648.png";